module.exports = __webpack_public_path__ + "img/Teamfoto.2ae5a42a.jpg";